export const ACTIONS = {
  FETCH_PURCHASE_ORDER: 'SERVICE_TOM__FETCH_PURCHASE_ORDER',
  SET_PURCHASE_ORDER_SCANNED_ITEMS: 'SERVICE_TOM__SET_PURCHASE_ORDER_SCANNED_ITEMS',
};
